import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeGTTModal } from "../../store/actions/orders";
import GTTModal from "./GTTModal";

const GTTModalHOC = () => {
  const dispatch = useDispatch();
  const gttModal = useSelector((state) => state.orders.gttModal);

  if (!gttModal?.open || !gttModal?.token || !gttModal?.exchange) {
    return null;
  }

  return <GTTModal {...gttModal} onClose={() => dispatch(closeGTTModal())} />;
};

export default GTTModalHOC;
